import { APICore } from './apiCore'

const api = new APICore()

function getGroupsContacts (params) {
  const baseUrl = '/groups-contacts'
  return api.get(baseUrl, params)
}

function getGroupsContact (id) {
  const baseUrl = `/groups-contacts/${id}`
  return api.get(baseUrl, {})
}

function addGroupsContact (params) {
  const baseUrl = '/groups-contacts'
  return api.create(baseUrl, params)
}

function updateGroupsContact (params) {
  const baseUrl = '/groups-contacts'
  return api.update(baseUrl, params)
}

function deleteGroupsContact (params) {
  const baseUrl = '/groups-contacts'
  return api.delete(baseUrl, params)
}

export { getGroupsContacts, getGroupsContact, addGroupsContact, updateGroupsContact, deleteGroupsContact }
